import {
  STATUS_FILTER_LABELS,
  overrideLabels,
  resolveOrder,
  type ResourceStatus
} from '@/shared/lib/status'

export type MissionUiStatus = ResourceStatus

/** Missão é feminina — override só do delta de concordância. */
export const MISSION_STATUS_LABELS = overrideLabels({
  success: 'Concluída',
  locked: 'Bloqueada',
  expired: 'Encerrada'
})

export const MISSION_SORT_PRIORITY = resolveOrder()

/* `ativas`, `ending` e `recommended` NÃO são status: são recortes sobre o
   conjunto. `ativas` cobre dois status ao mesmo tempo, `ending` é janela de
   tempo e `recommended` é ranking por recompensa. Por isso a união do filtro é
   mais larga que `ResourceStatus` e a correspondência precisa de predicado
   próprio — ver `matchesFilter` em `useMissionsListView`. */
export type MissionFilterId =
  | 'all'
  | 'ativas'
  | 'ending'
  | 'recommended'
  | 'new'
  | Extract<ResourceStatus, 'success' | 'locked'>

const FILTER_LABELS = overrideLabels(
  { success: 'Concluídas', locked: 'Bloqueadas' },
  STATUS_FILTER_LABELS
)

/* "Todas" primeiro e como estado inicial: era a única listagem de recurso que
   abria num filtro específico (`ativas`) e nem sequer tinha a opção. */
export const MISSION_FILTERS: { id: MissionFilterId; label: string }[] = [
  { id: 'all', label: 'Todas' },
  { id: 'new', label: 'Novas' },
  { id: 'ativas', label: 'Ativas' },
  { id: 'ending', label: 'Encerrando' },
  { id: 'recommended', label: 'Recomendadas' },
  { id: 'success', label: FILTER_LABELS.success },
  { id: 'locked', label: FILTER_LABELS.locked }
]

/** Missões com término em até 24h entram no filtro Encerrando. */
export const MISSION_ENDING_SOON_HOURS = 24
